/**
 * Styles for the preorder modal. Same pattern as the notify-me modal: a
 * single injected <style> tag with `stoq-` prefixed classes; merchant colors
 * are applied inline. Element helpers (el / trapFocus) are shared with
 * src/modal/dom.ts.
 */

export const PREORDER_STYLE_TAG_ID = 'stoq-sdk-preorder-styles'

const CSS = `
.stoq-preorder-overlay{position:fixed;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(33,34,35,.55);padding:16px;box-sizing:border-box}
.stoq-preorder-modal{position:relative;width:100%;max-width:460px;max-height:90vh;overflow-y:auto;padding:24px;box-shadow:0 10px 30px rgba(0,0,0,.25);box-sizing:border-box;-webkit-font-smoothing:antialiased}
.stoq-preorder-modal:focus{outline:none}
.stoq-preorder-modal *{box-sizing:border-box;margin:0}
.stoq-preorder-header{font-size:1.25em;font-weight:600;line-height:1.3;margin-bottom:12px;padding-right:32px}
.stoq-preorder-close{position:absolute;top:12px;right:12px;width:32px;height:32px;display:flex;align-items:center;justify-content:center;border:none;background:transparent;color:inherit;cursor:pointer;border-radius:4px;font-size:20px;line-height:1;padding:0}
.stoq-preorder-close:hover{background:rgba(0,0,0,.06)}
.stoq-preorder-error{font-size:.9em;color:#d72c0d;background:#fde2de;border-radius:6px;padding:8px 12px;margin-bottom:12px}
.stoq-preorder-product{display:flex;align-items:center;gap:12px;margin-bottom:12px}
.stoq-preorder-product-image{width:56px;height:56px;object-fit:cover;border-radius:6px;flex:none}
.stoq-preorder-product-info{flex:1;min-width:0}
.stoq-preorder-product-title{font-size:1em;font-weight:600;line-height:1.3}
.stoq-preorder-variant-title{font-size:.85em;opacity:.75;margin-top:2px}
.stoq-preorder-qty{display:flex;align-items:center;border:1px solid #dfe3e8;border-radius:6px;overflow:hidden;flex:none}
.stoq-preorder-qty-button{width:32px;height:36px;border:none;background:transparent;color:inherit;cursor:pointer;font-size:16px;line-height:1;padding:0}
.stoq-preorder-qty-button[disabled]{opacity:.4;cursor:default}
.stoq-preorder-qty-input{width:44px;height:36px;border:none;border-left:1px solid #dfe3e8;border-right:1px solid #dfe3e8;text-align:center;font:inherit;color:inherit;background:transparent;-moz-appearance:textfield;appearance:textfield}
.stoq-preorder-qty-input::-webkit-outer-spin-button,.stoq-preorder-qty-input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}
.stoq-preorder-disclaimer{font-size:.9em;line-height:1.45;margin-bottom:12px}
.stoq-preorder-details{list-style:disc;padding-left:20px;font-size:.9em;line-height:1.5;margin-bottom:12px}
.stoq-preorder-payment-heading{font-size:1em;font-weight:600;margin-bottom:8px}
.stoq-preorder-payment{border:1px solid #dfe3e8;border-radius:8px;margin-bottom:12px}
.stoq-preorder-payment-option{display:block;padding:12px;cursor:pointer}
.stoq-preorder-payment-option + .stoq-preorder-payment-option{border-top:1px solid #dfe3e8}
.stoq-preorder-payment-option-row{display:flex;align-items:center;gap:8px}
.stoq-preorder-payment-input{flex:none;margin:0;accent-color:currentColor}
.stoq-preorder-payment-title{font-size:.95em;font-weight:600;cursor:pointer}
.stoq-preorder-discount-badge{font-size:.75em;font-weight:600;padding:2px 8px;border-radius:999px;background:rgba(0,128,96,.12);color:#008060;margin-left:auto}
.stoq-preorder-payment-description{font-size:.85em;line-height:1.4;opacity:.8;margin-top:4px;padding-left:24px}
.stoq-preorder-ack{display:flex;align-items:flex-start;gap:8px;font-size:.9em;line-height:1.4;margin-bottom:12px;cursor:pointer}
.stoq-preorder-ack input{flex:none;margin-top:3px}
.stoq-preorder-actions{display:flex;flex-direction:column;gap:8px;margin-top:4px}
.stoq-preorder-confirm{width:100%;padding:12px 16px;font:inherit;font-weight:600;border:none;border-radius:6px;cursor:pointer}
.stoq-preorder-confirm[disabled]{opacity:.5;cursor:default}
.stoq-preorder-cancel{width:100%;padding:10px 16px;font:inherit;border:1px solid #dfe3e8;background:transparent;color:inherit;border-radius:6px;cursor:pointer}
`

/** Injects the preorder stylesheet once per document. */
export function injectPreorderStyles(doc: Document): void {
  if (doc.getElementById(PREORDER_STYLE_TAG_ID)) return
  const style = doc.createElement('style')
  style.id = PREORDER_STYLE_TAG_ID
  style.textContent = CSS
  doc.head.appendChild(style)
}
